import React, { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';

import { ListingPageHeader } from '@futrli/ui-components/components/listing-page/listing-page-header/listing-page-header';
import { PREDICT_NAV_HEIGHT } from '@futrli/predict/hooks/useNavHeight';
import { useApiView } from '@futrli/views/hooks/useApiView';
import { WorkspacesListView } from '@futrli/views/views/workspaces/WorkspacesListView/WorkspacesListView';

import { OrganisationsActionsProvider } from '../../context/organisations-actions-context/organisations-actions-context';
import { useWorkspacesFilters } from '../../hooks/use-workspaces-filters/use-workspaces-filters';
import { WorkspacesOrganisationsList } from '../../components/workspaces-organisations-list/workspaces-organisations-list';
import { WorkspacesOrganisationsListFilterBar } from '../../components/workspaces-organisations-list-filter-bar/workspaces-organisations-list-filter-bar';

export const WorkspacesListContainer = () => {
  const flags = useFlags();
  const intl = useIntl();

  const view = useApiView(useMemo(() => new WorkspacesListView(flags, true), [flags]));
  const { workspaces, isLoading } = view.state;

  const {
    searchTerm,
    onSearchChange,
    onWorkspaceFilterChange,
    onDatasourceFilterChange,
    onStatusFilterChange,
    filteredWorkspaces,
    workspaceFilterValue,
    datasourceFilterValue,
    statusFilterValue
  } = useWorkspacesFilters(workspaces || []);

  return (
    <OrganisationsActionsProvider>
      <Box margin="auto" padding="32px 0">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <ListingPageHeader
            title={intl.formatMessage({
              id: 'predict.workspaces.workspaces_list_title',
              defaultMessage: 'Workspaces'
            })}
          />
        </Box>
        <WorkspacesOrganisationsListFilterBar
          onSearchChange={onSearchChange}
          onWorkspaceFilterChange={onWorkspaceFilterChange}
          onDatasourceFilterChange={onDatasourceFilterChange}
          onStatusFilterChange={onStatusFilterChange}
          searchTerm={searchTerm}
          stickyTop={PREDICT_NAV_HEIGHT}
          datasourceFilterValue={datasourceFilterValue}
          statusFilterValue={statusFilterValue}
          workspaceFilterValue={workspaceFilterValue}
          workspaces={workspaces}
        />
        <Box mt={3}>
          <WorkspacesOrganisationsList workspaces={filteredWorkspaces} isLoading={isLoading} />
        </Box>
      </Box>
    </OrganisationsActionsProvider>
  );
};
